import { Component, OnInit, Input } from '@angular/core';
import { StorageManagerService } from '../../shared/services/index';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { BaseAccordionComponent } from '../base-accordion/base-accordion.component';

@Component({
  selector: 'app-submission-identification-classification-us',
  templateUrl: './submission-identification-classification-us.component.html',
  styleUrls: ['./submission-identification-classification-us.component.css']
})

export class SubmissionIdentificationClassificationUsComponent extends BaseAccordionComponent implements OnInit {

  constructor (public fb: FormBuilder, public storage: StorageManagerService) {
    super(fb, storage);
  }

  ngOnInit() {

    this.itemType = this.itemData.documentType;

    this.dataScope = this.storage.read('dataScope');

    this.initializeMainForm();

    this.patchForms();
  }

  initializeMainForm() {

    this.deviceForm = this.fb.group({
      udiDI: ['', { validators: [] }],
      agency: ['', { validators: [] }],
      budi: ['', { validators: [] }],
      bAgency: ['', { validators: [] }],
      quantityOfDevice: ['', { validators: [] }],
      unitOfUseDi: ['', { validators: [] }],
      unitOfUseDiAgency: ['', { validators: [] }],
      referenceOrCatalogNumber: ['', { validators: [] }],
      highIntencityRadiation: ['', { validators: [] }],
      equipmentToDestroyTissue: ['', { validators: [] }],
      intendedForInjection: ['', { validators: [] }],
      isDeviceDirectlyMarked: ['', { validators: [] }],
      directMarkingDI: ['', { validators: [] }],
      directMarkingDIAgency: ['', { validators: [] }],
      isExpirationDate: ['', { validators: [] }],
      isManufacturingDate: ['', { validators: [] }],
      isLotOrBatchNumber: ['', { validators: [] }],
      isSerialNumber: ['', { validators: [] }],
      isSwVersion: ['', { validators: [] }],
      urlForAdditionalInfo: ['', { validators: [] }],
      tradeNamesForm: this.fb.array([this.addTradeNamesForm()]),
      deviceDescriptionForm: this.fb.array([this.addDeviceDescriptionForm()]),
      cndCodesForm: this.fb.array([this.addCndCodesForm()]),
      emdnCodesForm: this.fb.array([this.addEmdnCodesForm()]),
      GMDNform: this.fb.array([this.addGMDNform()]),
      secondaryDiForm: this.fb.array([this.addSecondaryDiForm()]),
      classificationCode: ['', { validators: [] }],
      originalClassificationCode: ['', { validators: [] }],
      hasDirectMarking: ['', { validators: [] }],
      isDirectMarkingDiSameAsPrimaryDi: ['', { validators: [] }],
      diDataCarrierTypesForm: this.fb.array([this.addDiDataCarrierTypesForm()]),
      versionOrModel: ['', { validators: [] }],
      softwareAsAMedicalDevice: ['', { validators: [] }],
      productGenericNames: ['', { validators: [] }],
      controlledByDonationIdentificationNumber: ['', { validators: [] }],
      fdaProductCodesForm: this.fb.array([this.addFdaProductCodesForm()]),
      previousDiForm: this.fb.array([this.addPreviousDiForm()]),
      labelerDuns: ['', { validators: [] }],
      directMarkingExempt: ['', { validators: [] }]
    });

    // Watch changes on the entire deviceForm
    this.deviceForm.valueChanges.subscribe(data => {
      this.logValidationErrors(this.deviceForm);
    });
  }

  addFdaProductCodesForm(): FormGroup {

    return this.fb.group({
      fdaProductCode: ['', { validators: [] }]
    });
  }

  addPreviousDiForm(): FormGroup {

    return this.fb.group({
      diValue: ['', { validators: [] }],
      diAgency: ['', { validators: [] }]
    });
  }

  addDiDataCarrierTypesForm(): FormGroup {
    return this.fb.group({
      value: ['', { validators: [] }]
    });
  }

  get previousDiForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('previousDiForm');
  }

  get fdaProductCodesForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('fdaProductCodesForm');
  }

  get GMDNform(): FormGroup {
    return <FormGroup>this.deviceForm.get('GMDNform');
  }

  get diDataCarrierTypesForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('diDataCarrierTypesForm');
  }

  get tradeNamesForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('tradeNamesForm');
  }

  get deviceDescriptionForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('deviceDescriptionForm');
  }

  get cndCodesForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('cndCodesForm');
  }

  get emdnCodesForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('emdnCodesForm');
  }

  get secondaryDiForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('secondaryDiForm');
  }

  addGMDNform(): FormGroup {

    return this.fb.group({
      name: ['', { validators: [] }],
      language: ['', { validators: [] }]
    });
  }

  addTradeNamesForm(): FormGroup {

    return this.fb.group({
      value: ['', { validators: [] }]
    });
  }

  addCndCodesForm(): FormGroup {

    return this.fb.group({
      cndCode: ['', { validators: [] }]
    });
  }

  addEmdnCodesForm(): FormGroup {

    return this.fb.group({
      emdnCode: ['', { validators: [] }]
    });
  }

  addDeviceDescriptionForm(): FormGroup {

    return this.fb.group({
      value: ['', { validators: [] }],
      language: ['', { validators: [] }]
    });
  }

  addSecondaryDiForm(): FormGroup {

    return this.fb.group({
      diValue: ['', { validators: [] }],
      diAgency: ['', { validators: [] }]
    });
  }

  patchForms() {
    this.deviceForm.patchValue({

      udiDI: this.displayItemData('Primary DI'),
      agency: this.displayItemData('Primary DI Issuing Agency'),
      budi: this.displayItemData('Basic UDI-DI'),
      bAgency: this.displayItemData('Basic UDI-DI Issuing Agency'),
      quantityOfDevice: this.displayItemData('Quantity of Device'),
      unitOfUseDi: this.displayItemData('Unit of Use DI'),
      unitOfUseDiAgency: this.displayItemData('Unit of Use DI Issuing Agency'),
      referenceOrCatalogNumber: this.displayItemData('Catalog or Reference Number'),
      isDeviceDirectlyMarked: this.displayItemData('Is the Device Directly Marked?'),
      directMarkingDI: this.displayItemData('Direct Marking DI'),
      directMarkingDIAgency: this.displayItemData('Direct Marking DI Issuing Agency'),
      isExpirationDate: this.displayItemData('Controlled by Expiration Date?'),
      isManufacturingDate: this.displayItemData('Controlled by Manufacturing Date?'),
      isLotOrBatchNumber: this.displayItemData('Controlled by Lot or Batch Number?'),
      isSerialNumber: this.displayItemData('Controlled by Serial Number?'),
      isSwVersion: this.displayItemData('Controlled By Software Version?'),
      urlForAdditionalInfo: this.displayItemData('URL for Additional Information'),
      classificationCode: this.displayItemData('NMPA Classification Code'),
      originalClassificationCode: this.displayItemData('NMPA Original Classification Code'),
      hasDirectMarking: this.displayItemData('Has Direct Marking DI?'),
      isDirectMarkingDiSameAsPrimaryDi: this.displayItemData('Is Direct Marking DI same as Primary DI?'),
      versionOrModel: this.displayItemData('Version or Model'),
      softwareAsAMedicalDevice: this.displayItemData('Software as a Medical Device'),
      productGenericNames: this.displayItemData('Product Name/Generic Name'),
      controlledByDonationIdentificationNumber: this.displayItemData('Controlled by Donation Identification Number?'),
      labelerDuns: this.displayItemData('Labeler DUNS Number'),
      directMarkingExempt: this.displayItemData('Device Subject to Direct Marking (DM), but Excepted?'),
    });

    this.deviceForm.setControl('tradeNamesForm', this.setTradeNamesForm());
    this.deviceForm.setControl('deviceDescriptionForm', this.setDeviceDescriptionForm());
    this.deviceForm.setControl('cndCodesForm', this.setCndCodesForm());
    this.deviceForm.setControl('emdnCodesForm', this.setEmdnCodesForm());
    this.deviceForm.setControl('secondaryDiForm', this.setSecondaryDiForm());
    this.deviceForm.setControl('diDataCarrierTypesForm', this.setDiDataCarrierTypesForm());
    this.deviceForm.setControl('GMDNform', this.setGMDNform());
    this.deviceForm.setControl('previousDiForm', this.setPreviousDiForm());
    this.deviceForm.setControl('fdaProductCodesForm', this.setFdaProductCodesForm());
  }

  setFdaProductCodesForm(): FormArray {

    const formArray = new FormArray([]);

    let items: any;

    items = this.displayItemData('FDA Product Code');

    if (items && items.length > 0) {
      items.forEach((code, i) => {
        formArray.push(

          this.fb.group({
            fdaProductCode: code[(this.getMapInnerPathName('FDA Product Code Value'))[0]]
          })
        );
      });
    }

    return formArray;
  }

  setPreviousDiForm(): FormArray {

    const formArray = new FormArray([]);

    let items: any;

    items = this.displayItemData('Previous DI');

    if (items && items.length > 0) {
      items.forEach((c, i) => {
        formArray.push(

          this.fb.group({
            diValue: c[(this.getMapInnerPathName('Previous DI Value'))[0]],
            diAgency: c[(this.getMapInnerPathName('Previous DI Issuing Agency'))[0]]
          })
        );
      });
    }

    return formArray;
  }

  setGMDNform(): FormArray {

    const formArray = new FormArray([]);

    let item: any;

    item = this.displayItemData('GMDN Code(s)');

    if (item && item.length > 0) {
      item.forEach((c, i) => {
        formArray.push(

          this.fb.group({
            code: c[(this.getMapInnerPathName('GMDN Code'))[0]]
          })
        );
      });
    }

    return formArray;
  }

  setDiDataCarrierTypesForm(): FormArray {

    const formArray = new FormArray([]);

    let types: any;

    types = this.displayItemData('DI Data Carrier Type');

    if (types && types.length) {
      types.forEach(c => {
        formArray.push(

          this.fb.group({
            value: c[(this.getMapInnerPathName('DI Data Carrier Type Value'))[0]]
          })
        );
      });
    }

    return formArray;
  }

  setTradeNamesForm(): FormArray {

    const formArray = new FormArray([]);

    let names: any;

    names = this.displayItemData('Brand or Trade Name(s)');

    if (names && names.length > 0) {
      names.forEach((c, i) => {
        formArray.push(

          this.fb.group({
            value: c[(this.getMapInnerPathName('Brand or Trade Name Value'))[0]]
          })
        );
      });
    }

    return formArray;
  }

  setDeviceDescriptionForm(): FormArray {

    const formArray = new FormArray([]);

    let items: any;

    items = this.displayItemData('Device Description');

    if (items && items.length > 0) {
      items.forEach((c, i) => {
        formArray.push(

          this.fb.group({
            value: c[(this.getMapInnerPathName('Device Description Value'))[0]],
            language: c[(this.getMapInnerPathName('Device Description Language'))[0]]
          })
        );
      });
    }

    return formArray;
  }

  setCndCodesForm(): FormArray {

    const formArray = new FormArray([]);

    let items: any;

    items = this.displayItemData('CND Code');

    if (items && items.length > 0) {
      items.forEach((code, i) => {
        formArray.push(

          this.fb.group({
            cndCode: code[(this.getMapInnerPathName('CND Code Value'))[0]]
          })
        );
      });
    }

    return formArray;
  }

  setEmdnCodesForm(): FormArray {

    const formArray = new FormArray([]);

    let items: any;

    items = this.displayItemData('EMDN Code');

    if (items && items.length > 0) {
      items.forEach((code, i) => {
        formArray.push(

          this.fb.group({
            emdnCode: code[(this.getMapInnerPathName('EMDN Code Value'))[0]]
          })
        );
      });
    }

    return formArray;
  }

  setSecondaryDiForm(): FormArray {

    const formArray = new FormArray([]);

    let items: any;

    items = this.displayItemData('Secondary DI');

    if (items && items.length > 0) {
      items.forEach((c, i) => {
        formArray.push(

          this.fb.group({
            diValue: c[(this.getMapInnerPathName('Secondary DI Value'))[0]],
            diAgency: c[(this.getMapInnerPathName('Secondary DI Issuing Agency'))[0]]
          })
        );
      });
    }

    return formArray;
  }
}

